export default function assessmentUniqueNameDirective(
  $q,
  bcpDataService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const assessmentId = attributes.assessmentId || 0;
    ngModel.$asyncValidators.bcpAsessmentUniqueName = (modelValue) => {
      const defer = $q.defer();
      bcpDataService.checkAssessmentExists(
        modelValue,
        assessmentId
      ).then((data) => {
        if (
          data
          && data.data.result === false
        ) {
          defer.resolve();
        } else {
          defer.reject();
        }
      }).catch(defer.reject);
      return defer.promise;
    };
  }
}

export const name = 'bcpAsessmentUniqueName';

assessmentUniqueNameDirective.$inject = [
  '$q',
  'bcpDataService'
];
